import { ca } from '@cian/analytics';

interface ITrackAllNewbuildingsClickParams {
  offerId: number;
}

export const trackAllNewbuildingsClick = (params: ITrackAllNewbuildingsClickParams) => {
  const { offerId } = params;

  ca('eventSite', {
    action: 'click_listingjk',
    category: 'Card',
    label: 'builder_block_JK',
    name: 'oldevent',
    page: {
      extra: {
        is_premium: true,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};
